import { Typography } from "@/design-system/Atoms";
import { LinkArrowButton } from "@/design-system/Atoms/Button/LinkButton";
import { usePatientCTAButtonConfig } from "@/hooks/usePatientCTAButtonConfig";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "@/routes/routes.config";


export const OralMedPriceOverviewSection = () => {
  const navigate = useNavigate();
  const { ctaButtonConfig, patientEntitlementsIsLoading } =
    usePatientCTAButtonConfig();
  return (
    <section className="pb-[4.68rem] lg:pb-[10rem]">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap justify-center">
          <div className="w-full h-[20rem] sm:h-[24rem] md:h-[28rem] lg:h-[40rem] max-w-full flex-shrink-0 text-center lg:w-1/2">
            <img
              src="/images/oralmed/72a6a6bdec97be4a796c1024c2be3025.jpg"
              alt="oral-med-price"
              className="h-full w-[98%] object-cover rounded-[20px] mb-4 lg:mb-0"
            />
          </div>
          <div className="w-full max-w-full flex-shrink-0 px-[0.75rem] lg:w-[41.666667%] lg:ml-[8.333333%] mt-12 ">
            <Typography
              variant="categoryText"
              as="div"
              className="mb-[3.125rem]"
            >
              Overview
            </Typography>
            <Typography variant="sectionHeading" as="h2" className="mb-10">
              <>
                Simple and Affordable Access to{" "}
                <span className="text-gray-400">Oral ED Medications</span>
              </>
            </Typography>
            <Typography variant="sectionDescriptionLarge" as="p" className="mb-4">
              Getting the treatment you need shouldn’t be complicated or expensive. We’ve made it easy to access trusted ED medications, focusing on affordability, privacy, and professional care.
            </Typography>
            <div className="inline-block pr-[0.75em] w-2xs  mt-10">
              <LinkArrowButton
                href=""
                label={ctaButtonConfig.text}
                onClick={() => {
                  if (ctaButtonConfig.text === "View Products") {
                    navigate(`${ROUTES.PRODUCTS_BASE}/category/PDE5`);
                  } else {
                    ctaButtonConfig.action();
                  }
                }}
                loading={patientEntitlementsIsLoading}
                className="mt-10 "
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OralMedPriceOverviewSection;
